angular.module('upModals.controllers').controller('InsertTag', [
	'$scope',
	'TagService',
	'$modalParams',
	'TagsService',
	'SegmentHelper',
	'$safeApply',
	function ($scope, TagService, $modalParams, TagsService, SegmentHelper, $safeApply) {
		var InsertTag = this;
		InsertTag.tags = [];

		InsertTag.selectTag = function (tag) {
			SegmentHelper.track('Selected tag ' + tag.value, SegmentHelper.module.tagPicker);
			$scope.resolve(tag);
		};

		var init = async function () {
			InsertTag.tagGroups = await TagsService.getMailTagList($modalParams);

			// Add extraTagGroups if provided (for form Extra fields)
			if ($modalParams.extraTagGroups) {
				InsertTag.tagGroups.push($modalParams.extraTagGroups);
			}

			InsertTag.originalTags = _.cloneDeep(InsertTag.tagGroups);

			$safeApply($scope);
		};

		InsertTag.searchUpdate = function () {
			if (InsertTag.search.length === 0) {
				InsertTag.tagGroups = InsertTag.originalTags;
				return;
			}

			InsertTag.tagGroups = _.reduce(
				InsertTag.originalTags,
				function (result, tagGroup) {
					var cloneGroup = _.cloneDeep(tagGroup);
					cloneGroup.tags = _.reduce(
						tagGroup.tags,
						function (result, tag) {
							if (cloneGroup.class && cloneGroup.class === 'th-inner--translation') {
								var cloneGroupTile = Tools.$translate(cloneGroup.title);
								var groupTileMatch =
									cloneGroupTile.toLowerCase().indexOf(InsertTag.search.toLowerCase()) !== -1;

								if (groupTileMatch) {
									result.push(tag);
								}
							} else if (tag.name.toLowerCase().indexOf(InsertTag.search.toLowerCase()) !== -1) {
								result.push(tag);
							}
							return result;
						},
						[]
					);

					if (cloneGroup.tags.length) {
						result.push(cloneGroup);
					}

					return result;
				},
				[]
			);
		};

		init();
	}
]);
